var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup28X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 22,
    fill: "#97A2C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4504 22H0V0H25.4504V22ZM0.629338 21.3703H24.8211V0.629651H0.629338V21.3703Z",
    fill: "#233A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1859 14.2051H0.314453V14.8347H25.1859V14.2051Z",
    fill: "#233A80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17426 0.327637H6.54492V14.52H7.17426V0.327637Z",
    fill: "#233A80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3798 0.365234H12.7505V21.6348H13.3798V0.365234Z",
    fill: "#233A80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1864 10.4521H13.1157V11.0818H25.1864V10.4521Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup28X);
export default __webpack_public_path__ + "static/media/Group28x.a7b42352a0bfa1cbf63cba251bdbb656.svg";
export { ForwardRef as ReactComponent };